import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SEARCH_RELATIVE_URL } from '../constants';
import Isvg from 'react-inlinesvg';
import navigate_before from '../img/icons/navigate_before.svg';
import navigate_next from '../img/icons/navigate_next.svg';
import navigate_first from '../img/icons/first_page.svg';
import navigate_last from '../img/icons/last_page.svg';
import Pagination from 'react-responsive-pagination';
import { isIE } from 'react-device-detect';
import { IsvgWrapper } from '../helpers';

export const Paging = ({
  history,
  numPages,
  currPage,
  searchKeyword,
  setPageNum,
}) => {
  let pageButtons = [];
  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(0);

  for (var i = 0; i < numPages; i++) {
    let tempPageNum = i + 1;
    pageButtons.push(
      <Link
        to={SEARCH_RELATIVE_URL + searchKeyword + '&p=' + tempPageNum}
        key={i}
        className={
          'paging__button paging__button--number' +
          (tempPageNum === currPage ? ' paging__button--active' : '')
        }
        aria-label={'Page ' + tempPageNum}
        onClick={setPageNum.bind(null, tempPageNum)}
      >
        {tempPageNum}
      </Link>
    );
  }

  const handlePageChange = (page) => {
    setPage(page);
    setCurrentPage(page);
    setPageNum(page);
    history.push(SEARCH_RELATIVE_URL + searchKeyword + '&p=' + page);
  };

  useEffect(() => {
    const paginationNext = document.querySelector('[aria-label="Next"]');
    const paginationPrevious = document.querySelector('[aria-label="Previous"');

    if (paginationNext) {
      paginationNext.innerHTML = '';
    }

    if (paginationPrevious) {
      paginationPrevious.innerHTML = '';
    }
  }, [page]);

  return isIE ? (
    <div className="paging-container">
      <div className="paging search-page__results-paging">
        {currPage > 1 && (
          <div className="paging__action-group paging__action-group--prev">
            <Link
              to={SEARCH_RELATIVE_URL + searchKeyword + '&p=' + (currPage - 1)}
              className="paging__button paging__button--prev"
              aria-label="Go to previous results page"
              onClick={setPageNum.bind(null, currPage - 1)}
            >
              <IsvgWrapper><Isvg src={navigate_before} /></IsvgWrapper>
            </Link>
            <Link
              to={SEARCH_RELATIVE_URL + searchKeyword + '&p=1'}
              className="paging__button paging__button--first"
              aria-label="Go to first results page"
              onClick={setPageNum.bind(null, 1)}
            >
              <IsvgWrapper><Isvg src={navigate_first} /></IsvgWrapper>
            </Link>
          </div>
        )}

        <div className="paging__numbers">{pageButtons}</div>

        {currPage < numPages && (
          <div className="paging__action-group paging__action-group--next">
            <Link
              to={SEARCH_RELATIVE_URL + searchKeyword + '&p=' + numPages}
              className="paging__button paging__button--last"
              aria-label="Go to last results page"
              onClick={setPageNum.bind(null, numPages)}
            >
              <IsvgWrapper><Isvg src={navigate_last} /></IsvgWrapper>
            </Link>
            <Link
              to={SEARCH_RELATIVE_URL + searchKeyword + '&p=' + (currPage + 1)}
              className="paging__button paging__button--next"
              aria-label="Go to next results page"
              onClick={setPageNum.bind(null, currPage + 1)}
            >
              <IsvgWrapper><Isvg src={navigate_next} /></IsvgWrapper>
            </Link>
          </div>
        )}
      </div>
    </div>
  ) : (
    <div className="paging-container">
      <Pagination
        total={numPages}
        current={currentPage}
        onPageChange={(page) => handlePageChange(page)}
      />
    </div>
  );
};
